import axios from '@_system/axios/axios.js'
export default {
	path: '/agencysendwarehouse',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	wlnlistTrades(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/wlnlistTrades', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	wlnlistTradeDetails(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/wlnlistTradeDetails', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getClearTradeMsg(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getClearTradeMsg', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	reportgoods(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/reportgoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	getbestsupplier(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getbestsupplier', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	autoreportgoodstask(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/autoreportgoodstask', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	getcostbysupplierid(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getcostbysupplierid', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	createpurchase(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/createpurchase', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/agencysendwarehouse.agencysendwarehouse', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
